import Icon from '../components/Icon';

const ClosureFilled = Icon(
  'closure-filled',
  <>
    <path
      fillRule="evenodd"
      d="M12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12 6.063 1.25 12 1.25M8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
      clipRule="evenodd"
    />
  </>
);

export default ClosureFilled;
